import { createSignal } from "solid-js";

/**
 * Whether the desktop sidebar is collapsed to its icon rail.
 *
 * Kept outside any component for the same reason as `chatDrawerStore`:
 * AppShell is mounted per-route in App.tsx, so a local signal would reset the
 * collapse on every navigation. Mirrored into `localStorage` so the choice
 * also survives a reload.
 */
const STORAGE_KEY = "flowicity_sidebar_collapsed";

function read(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

const [sidebarCollapsed, setCollapsed] = createSignal(read());

export function setSidebarCollapsed(collapsed: boolean): void {
  setCollapsed(collapsed);
  try {
    localStorage.setItem(STORAGE_KEY, String(collapsed));
  } catch {
    // Storage unavailable (private mode, quota) — in-memory state still works.
  }
}

export { sidebarCollapsed };
